import { render, staticRenderFns } from "./SlotMenu.vue?vue&type=template&id=3665233b"
import script from "./SlotMenu.vue?vue&type=script&lang=js"
export * from "./SlotMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports